import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { environment } from 'src/environments/environment';
import { Dashboard } from './home.interface';

const baseUrl = `${environment.baseUrl}dashboard`;

@Injectable({
  providedIn: 'root'
})
export class HomeService {

  constructor(private http: HttpClient) { }

  getDashboardData(req: Dashboard) {
    return this.http.post<any>(`${baseUrl}/getDashboardStaticData`, req);
  }
}
